import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import { ThemeContext } from '../contexts'
import { useStyles } from '../hooks/useStyles/useStyles'

const styles = (theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
})

const ApplicationScreenWrapper = ({ children }) => {
  const themeContext = useContext(ThemeContext)

  const classes = useStyles(styles, themeContext)

  return (
    <React.Fragment>
      <main className={classes.content}>{children}</main>
    </React.Fragment>
  )
}

ApplicationScreenWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
}

export default ApplicationScreenWrapper
